<script setup lang="ts">
	const rConf = useRuntimeConfig()

	const serviceareas = ref({})
	const cachedData = useNuxtData('serviceareas')
	if (cachedData.data.value) {
		serviceareas.value = cachedData.data.value
	} else {
		const { data } = await useFetch('/rest/serviceareas', {
			baseURL: rConf.public.apiBase,
			query: { is_featured: true, is_active: true },
			key: 'serviceareas'
		})
		if(data.value) {
			serviceareas.value = data.value
		}
	}
</script>

<template>
	<span v-if="serviceareas?.items" class="flex flex-col gap-5 2xl:gap-5.5 px-3 py-4 bg-white lg:-mt-6.5">
		<NuxtLink v-for="(item,idx) in serviceareas.items" :key="item.id" :to="{name: 'servicearea-detail', params: { servicearea_slug: item.slug }}"
			  class="leading-none relative font-thin text-[1rem] whitespace-nowrap transition duration-500 ease-in-out"
			  :title="item.title" no-prefetch
	>
			<template v-if="item.title_short">{{ item.title_short }}</template>
			<template v-else>{{ item.title }}</template>
		</NuxtLink>
	</span>
</template>
